import React from 'react';
import { PropTypes, string, array } from 'prop-types';
import classNames from 'classnames';

import { IconDiscount } from '../../components/Icons';

import css from './Helper.module.css';

const Helper = (props) => {
  const { className, text } = props;
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <IconDiscount className={css.iconDiscount} />
      {
        Array.isArray(text) ?
        text.map(el =>
        <span key={el} className={css.text}>{el}</span>) :
        <span className={css.text}>{text}</span>
      }
    </div>
  )
}

Helper.defaultProps = {
  className: null,
};

Helper.propTypes = {
  className: string,
  text: PropTypes.oneOfType([
    string.isRequired,
    array.isRequired
  ]),
};

export default Helper;
